// /** @format */

// import React, { useEffect, useState } from "react";
// import { getApi } from "../../Repository/Api";
// import DynamicHelmet from "../Helmet/DynamicHelmet";
// import endPoints from "../../Repository/apiConfig";
// import { ImageLazyLoading } from "../../utils/helpingComponent";
// import { useNavigate } from "react-router-dom";

// const PaymentPlan = () => {
//   const [metaResponse, setMetaResponse] = useState(null);
//   const navigate = useNavigate();

//   const fetchMetaTags = () => {
//     getApi({
//       url: endPoints.metaTags.paymentplanPage,
//       setResponse: setMetaResponse,
//     });
//   };

//   useEffect(() => {
//     fetchMetaTags();
//   }, []);

//   useEffect(() => {
//     const script = document.createElement("script");

//     script.innerHTML = `
//         (function (w, d, s, o, f, js, fjs) {
//           w[o] =
//             w[o] ||
//             function () {
//               (w[o].q = w[o].q || []).push(arguments);
//             };
//           (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
//           js.id = o;
//           js.src = f;
//           js.async = 1;
//           fjs.parentNode.insertBefore(js, fjs);
//         })(
//           window,
//           document,
//           "script",
//           "_hw",
//           "https://files.withcherry.com/widgets/widget.js"
//         );
  
//         _hw(
//           "init",
//           {
//             debug: false,
//             variables: {
//               slug: "shahinahoja",
//               name: "Shahina Hoja Aesthetics"
//             },
//             styles: {
//               primaryColor: "#042b26",
//               secondaryColor: "#e5d896",
//               fontFamily: "Open Sans"
//             }
//           },
  
//           ["all", "hero", "howitworks", "testimony", "faq", "calculator"]
//         );`;

//     const head = document.querySelector("head");
//     head.appendChild(script);

//     return () => {
//       head.removeChild(script);
//     };
//   }, []);

//   return (
//     <>
//       {metaResponse && (
//         <DynamicHelmet
//           title={metaResponse?.data?.title}
//           description={metaResponse?.data?.description}
//         />
//       )}

//       <div className="Backward_Heading step_Heading">
//         <div>
//           <ImageLazyLoading
//             img={"https://shahinaimage.s3.us-west-1.amazonaws.com/shahina_1755677386398.png"}
//             onClick={() => navigate(-1)}
//             alt={"Go Back"}
//           />
//         </div>
//       </div>

//       <div id="all"></div>
//     </>
//   );
// };

// export default PaymentPlan;


/** @format */
import React, { useEffect, useState } from "react";
import { getApi } from "../../Repository/Api";
import DynamicHelmet from "../Helmet/DynamicHelmet";
import endPoints from "../../Repository/apiConfig";
import { ImageLazyLoading } from "../../utils/helpingComponent";
import { useNavigate } from "react-router-dom";

const PaymentPlan = () => {
  const [metaResponse, setMetaResponse] = useState(null);
  const [cherryAvailable, setCherryAvailable] = useState(true);
  const navigate = useNavigate();

  // ✅ Fetch page SEO
  useEffect(() => {
    getApi({
      url: endPoints.metaTags.paymentplanPage,
      setResponse: setMetaResponse,
    });
  }, []);

  // ✅ Detect visitor country and show fallback if not US
  useEffect(() => {
    const checkCountry = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();
        const country = data?.country_name || "";
        console.log("🌍 Visitor Country:", country);

        // Cherry only available in the USA
        if (country.toLowerCase() !== "united states") {
          setCherryAvailable(false);
        } else {
          setCherryAvailable(true);
        }
      } catch (error) {
        console.warn("Country check failed:", error);
        // if API fails, fallback to showing Cherry (safe default)
        setCherryAvailable(true);
      }
    };

    checkCountry();
  }, []);

  return (
    <>
      {metaResponse && (
        <DynamicHelmet
          title={metaResponse?.data?.title}
          description={metaResponse?.data?.description}
        />
      )}

      {/* Back Button */}
      <div className="Backward_Heading step_Heading">
        <div>
          <ImageLazyLoading
            img="https://shahinaimage.s3.us-west-1.amazonaws.com/shahina_1755677386398.png"
            onClick={() => navigate(-1)}
            alt="Go Back"
          />
        </div>
      </div>

      {/* ✅ If Cherry available → show widget */}
      {cherryAvailable ? (
        <>
          <div id="hero"></div>
          <div id="howitworks"></div>
          <div id="testimony"></div>
          <div id="faq"></div>
          <div id="calculator"></div>
        </>
      ) : (
        /* ❌ If not available → show fallback */
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
          <img
            src="https://cdn-icons-png.flaticon.com/512/564/564619.png"
            alt="Not Available"
            className="w-24 h-24 mb-4 opacity-80"
          />
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">
            Cherry is not available in your country
          </h2>
          <p className="text-gray-600 max-w-md">
            Unfortunately, Cherry’s financing options are only available in the United States.
            Please contact our team for alternative payment methods.
          </p>
        </div>
      )}
    </>
  );
};

export default PaymentPlan;

